import React from "react";
import { useTranslation } from "react-i18next";
import arrowUp from "../svg/arrowUp.svg";

/** Scrolls the page to the top — used beside Favourites "View All" actions. */
export const FavGotoTopButton: React.FC = () => {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      className="fav-goto-top"
      onClick={scrollToTop}
      aria-label={t("go_to_top_tr")}
      title={t("go_to_top_tr")}
    >
      <img src={arrowUp} alt="" width={16} height={10} />
    </button>
  );
};
